var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelsShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.333984,
    width: 30,
    height: 30,
    rx: 5,
    fill: "#D4F7DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3329 15.1252C16.1745 15.1252 16.0162 15.0669 15.8912 14.9419C15.6495 14.7002 15.6495 14.3002 15.8912 14.0585L22.7245 7.2252C22.9662 6.98353 23.3662 6.98353 23.6079 7.2252C23.8495 7.46686 23.8495 7.86686 23.6079 8.10853L16.7745 14.9419C16.6495 15.0669 16.4912 15.1252 16.3329 15.1252Z",
    fill: "#21AA47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.833 11.626C23.4913 11.626 23.208 11.3426 23.208 11.001V7.62598H19.833C19.4913 7.62598 19.208 7.34264 19.208 7.00098C19.208 6.65931 19.4913 6.37598 19.833 6.37598H23.833C24.1747 6.37598 24.458 6.65931 24.458 7.00098V11.001C24.458 11.3426 24.1747 11.626 23.833 11.626Z",
    fill: "#21AA47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 24.2926H13.0003C8.47533 24.2926 6.54199 22.3593 6.54199 17.8343V12.8343C6.54199 8.30931 8.47533 6.37598 13.0003 6.37598H14.667C15.0087 6.37598 15.292 6.65931 15.292 7.00098C15.292 7.34264 15.0087 7.62598 14.667 7.62598H13.0003C9.15866 7.62598 7.79199 8.99264 7.79199 12.8343V17.8343C7.79199 21.676 9.15866 23.0426 13.0003 23.0426H18.0003C21.842 23.0426 23.2087 21.676 23.2087 17.8343V16.1676C23.2087 15.826 23.492 15.5426 23.8337 15.5426C24.1753 15.5426 24.4587 15.826 24.4587 16.1676V17.8343C24.4587 22.3593 22.5253 24.2926 18.0003 24.2926Z",
    fill: "#21AA47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelsShare);
export default __webpack_public_path__ + "static/media/reels_share.d3a0581b69035cf6bcdcfd910076ab68.svg";
export { ForwardRef as ReactComponent };